<template>
  <div class="confirmActive">
    <h3c-server-table
      :class="['serverTable', borderShow ? 'borderShow' : '']"
      ref="tableObj"
      stripe
      :border="borderShow"
      :url="url"
      :defaultParam="defaultParam"
      :span-method="arraySpanMethod"
      :otherColumn="otherColumn"
      listKey="res.data"
      :hasPage="false"
      @data-load-success="dataLoad"
    >
      <template v-for="column in columns">
        <el-table-column
          fixed="left"
          v-if="column.show && column.prop === 'getActive'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div>
              <!-- 成功 -->
              <div
                class="getActiveClass"
                v-if="!scope.row.errMsg"
                @click="getActiveFile()"
              >
                <img
                  class="getActiveImg"
                  src="../../../assets/img/save.svg"
                  alt=""
                />
                <span class="getActiveText">获取激活文件</span>
              </div>
              <div class="getActiveClass" v-else>
                <img
                  class="getActiveImg"
                  src="../../../assets/img/errorTip.svg"
                  alt=""
                />
                <el-tooltip placement="top" :content="scope.row.errMsg">
                  <span class="getActiveText">查看失败信息</span>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          v-else-if="column.show && column.prop === 'deviceTag'"
          :key="column.prop"
          v-bind="column"
        >
        </el-table-column>
        <el-table-column
          v-else-if="column.show && column.prop === 'effectiveDays'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.effectiveDays == -1 ? '永久' : scope.row.effectiveDays
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.show"
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
    </h3c-server-table>
    <dialog-common
      v-if="dialogCommonVisible"
      :visible.sync="dialogCommonVisible"
      title="获取激活文件"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose"
    >
      <div>
        <span style="margin-right: 10px">请选择激活文件获取方式：</span>
        <el-checkbox-group style="display: inline-block" v-model="checkList"
          ><el-checkbox label="下载激活文件"></el-checkbox
          ><el-checkbox label="邮件发送激活文件"></el-checkbox
        ></el-checkbox-group>
      </div>
    </dialog-common>
  </div>
</template>
<script>
import h3cServerTable from '~/components/h3c-server-table-get.vue';
import zgyLicenseReq from '~/request/zgyLicenseReq';
import DialogCommon from './Dialog/DialogCommon';
export default {
  components: {
    h3cServerTable,
    DialogCommon,
  },
  data() {
    return {
      // 异步获取
      isTip: false,
      otherColumn: {
        selection: null,
        columnIndex: {
          className: 'indexColumnClass',
          width: 80,
        },
      },
      borderShow: false,
      activeTableData: [],
      needMergeArr: ['activeFileName'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
      isMerge: false,
      url: '',
      defaultParam: {},
      resultData:[],
      columns: [
        {
          label: '获取激活信息',
          prop: 'getActive',
          minWidth: '200',
          show: false,
        },
        {
          label: '自定义设备标识',
          prop: 'deviceTag',
          minWidth: '230',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '授权码',
          prop: 'licenseNo',
          minWidth: '360',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '软件条码',
          prop: 'licenseSn',
          minWidth: '200',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '产品型号',
          prop: 'displayFeatureName',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '产品描述',
          prop: 'chineseDesc',
          minWidth: '130',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '授权码状态',
          prop: 'licenseStatusName',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '授权码类型',
          prop: 'licenseTypeName',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
        {
          label: '剩余有效时限（天）',
          prop: 'effectiveDays',
          minWidth: '160',
          'show-overflow-tooltip': true,
          sortable: true,
          show: true,
        },
      ],
      dialogCommonVisible: false,
      checkList: ['下载激活文件'],
      zipUrl: '',
    };
  },
  created() {
    this.defaultParam = {
      processNo: sessionStorage.getItem('processNo'),
      currentStep: 4,
      page: 1,
      size: 9999,
    };
    this.url = zgyLicenseReq.getListUrl;
    this.getUserInfo();
  },
  methods: {
    //激活后刷新列表，并显示出隐藏的首列
    updateTable() {
      this.columns[0].show = true;
      this.$refs.tableObj.refreshData();
    },
    //存储用户Id，便于下载激活文件
    getUserInfo() {
      const processNo = sessionStorage.getItem('processNo');
      zgyLicenseReq.getUser(processNo).then(res => {
        if (res.status && res.res) {
          sessionStorage.setItem('customerId', res.res.id);
        }
      });
    },
    //获取激活文件
    getActiveFile() {
      this.dialogCommonVisible = true;
      this.checkList = ['下载激活文件'];
    },
    //激活文件弹框
    handleClose() {
      this.dialogCommonVisible = false;
    },
    handleConfirm() {
      if (!this.checkList.length) {
        this.handleClose();
      } else {
        if (this.checkList.includes('下载激活文件')) {
          window.location.href = sessionStorage.getItem('activeFileUrl');
        }
        if (this.checkList.includes('邮件发送激活文件')) {
          let customerId = sessionStorage.getItem('customerId');
          let zipUrl = sessionStorage.getItem('activeFileUrl');
          let processNo = sessionStorage.getItem('processNoForEmail');
          zgyLicenseReq
            .sendEmailToActive(customerId, zipUrl, processNo)
            .then(res => {
              if (res.status) {
                this.handleClose();
                this.$notify({
                  title: '成功',
                  message: '邮件发送激活文件成功',
                  type: 'success',
                });
              } else {
                this.$notify({
                  title: '失败',
                  message: res.msg || '邮件发送激活文件失败',
                  type: 'error',
                });
              }
            });
        }
      }
    },
    getActiveTableData() {
      if (this.isTip) {
        this.$alert(`${this.activeTableData[0].activeInfo}`, '激活结果提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showClose: true,
          customClass: 'alertClass',
        });
        // 异步情况
        return false;
      }
      return this.activeTableData;
    },
    seeHelp() {
      window.open(`${location.origin}/document/license_activation_step4.html`);
    },
    dataLoad(data){
      this.resultData = data.res.data;

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'getActive') {
        //判断是getActive列才能合并
        if (!row.errMsg && this.resultData[rowIndex-1].errMsg) {
          return { rowspan: this.resultData.length - rowIndex, colspan: 1 };
        }
        if(!row.errMsg && !this.resultData[rowIndex-1].errMsg){
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    mergeAction(val, rowIndex, colData) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },
  },
};
</script>
<style lang="less" scoped>
.confirmActive {
  height: 100%;
  display: flex;
  flex-direction: column;
  .operateClass {
    text-align: right;
    margin-bottom: 16px;
  }
  .serverTable {
    flex: 1;
    &.borderShow {
      /deep/ .el-table {
        border: 1px solid #ebeef5;
      }
      /deep/ .el-table__cell {
        border-bottom: 1px solid #ebeef5;
      }
    }
    /deep/ .indexColumnClass {
      padding-left: 10px !important;
    }
    .getActiveClass {
      display: flex;
      align-items: center;
      cursor: pointer;
      .getActiveImg {
        margin-right: 10px;
      }
      .getActiveText {
        border: 1px solid #e6e8ec;
        padding: 2px 10px;
        background-color: #fff;
      }
    }
  }
}
</style>